import React from 'react';

export default function Footer() {
    return (
        <div className="footer-section">
            <p className="footer-text">
                Copyright @ 2026 Codeoly All rights reserved.
            </p>
        </div>
    );
}